@if (!isPrintPDFRoute) {
  <div class="toggle" [ngClass]="{'toggle--footer': isFloatingToggle}">
    <div class="toggle__wrapper">
      <!--
      Toggle figure on floating toggle should show
      both full and shortened toggle figure states
      -->
      @if (isFloatingToggle) {
        @if (isMobileStyles) {
          <ng-container *ngTemplateOutlet="shortenedToggle"></ng-container>
        }
        @if (!isMobileStyles) {
          <ng-container *ngTemplateOutlet="fullToggle"></ng-container>
        }
      }
      <!--
      Toggle figure not on floating toggle (e.g. on hero header)
      should only show full toggle figure
      *This is because the floating footer attaches a "Hide figures?"
      label next to the shortened toggle to fill in the missing context
      for what the toggle will show/hide.
      -->
      @if (!isFloatingToggle) {
        <ng-container *ngTemplateOutlet="fullToggle"></ng-container>
      }
      <span class="toggle__indicator"></span>
    </div>
  </div>
}

<!-- Full Toggle: [ Hide figures | Show figures ] -->
<ng-template #fullToggle>
  <button [ngClass]="{'toggle__link--active': isFiguresHide}" class="toggle__link"
    (click)="setState('hide')"><span [innerText]="'Hide figures' | translate"></span></button>
    <button [ngClass]="{'toggle__link--active': !isFiguresHide}" class="toggle__link"
      (click)="setState('show')"><span [innerText]="'Show figures' | translate"></span></button>
    </ng-template>

    <!-- Shortened Toggle: [ Hide | Show ] -->
    <ng-template #shortenedToggle>
      <button [ngClass]="{'toggle__link--active': isFiguresHide}" class="toggle__link"
        (click)="setState('hide')"><span [innerText]="'Hide' | translate"></span></button>
        <button [ngClass]="{'toggle__link--active': !isFiguresHide}" class="toggle__link"
          (click)="setState('show')"><span [innerText]="'Show' | translate"></span></button>
        </ng-template>
